import { IsOptional, IsUUID, IsString, IsNumber, IsEnum, IsNotEmpty, IsObject, Min, IsBoolean, IsArray } from 'class-validator';
import { DiscountTypeEnum, MembershipTierFrequencyEnum } from '../../enums';

export class DiscountDto {
	id: string;
	baseDiscountId: string;
	code: string;
	amount: number;
	type: DiscountTypeEnum;
	uses: number;
	maxUses?: number;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;

	discountToEvents?: DiscountToEventDto[];
	discountToMemberships?: DiscountToMembershipDto[];
	discountToChallenges?: DiscountToChallengeDto[];
	discountToTrackingLinks?: DiscountToTrackingLinkDto[];
}

export class DiscountToEventDto {
	public id: string;
	public discountId: string;
	public eventId: string;
	public eventPriceId?: string;

	public discount?: DiscountDto;
}

export class DiscountToMembershipDto {
	public id: string;
	public discountId: string;
	public membershipId: string;
	public membershipTierId?: string;

	public discount?: DiscountDto;
}

// TODO implement promo codes logic for challenges in discount.service.ts and payments.service.ts
export class DiscountToChallengeDto {
	public id: string;
	public discountId: string;
	public challengeId: string;

	public discount?: DiscountDto;
}

export class DiscountToTrackingLinkDto {
	public id: string;
	public trackingLinkId: string;
	public baseDiscountId: string;
	public eventPriceBaseId?: string;
	public createdAt: Date;
	public updatedAt: Date;

	public discount?: DiscountDto;
}

export class UpsertDiscountDto {
	@IsOptional()
	@IsUUID()
	id?: string;

	@IsNotEmpty()
	@IsString()
	code: string;

	@IsNotEmpty()
	@IsNumber()
	@Min(0)
	amount: number;

	@IsNotEmpty()
	@IsEnum(DiscountTypeEnum)
	type: DiscountTypeEnum;

	@IsOptional()
	@IsNumber()
	@Min(0)
	maxUses?: number | null;
}

/** @deprecated Please use SetEventDiscountDto instead */
export class UpsertEventDiscountDto extends UpsertDiscountDto {
	/**
	 * { all: true }
	 * OR
	 * {
	 *    '<EXISTING_PRICE_UUID_1>': true,
	 *    '<EXISTING_PRICE_UUID_2>',
	 *    <NEW_PRICE_INDEX_NUMBER_0>: true,
	 *    <NEW_PRICE_INDEX_NUMBER_1>: true,
	 *  }
	 * */
	@IsNotEmpty()
	@IsObject()
	public eventPrices: DiscountRelationFlags<string>;
}

export class CreateMembershipDiscountDto extends UpsertDiscountDto {
	/**
	 * { all: true }
	 * OR
	 * {
	 *   weekly: true,
	 *   monthly: true
   * }
	 * */
	@IsNotEmpty()
	@IsObject()
	public membershipTiers: DiscountRelationFlags<MembershipTierFrequencyEnum>;
}

export class CreateTrackingLinkDiscountDto extends UpsertDiscountDto {
	/**
	 * { all: true }
	 * OR
	 * {
	 *    '<EXISTING_PRICE_UUID_1>': true,
	 *    '<EXISTING_PRICE_UUID_2>',
	 *  }
	 * */
	@IsNotEmpty()
	@IsObject()
	public eventPrices: DiscountRelationFlags<string>;
}

export type DiscountRelationFlags<K extends string = string> =
	| {
			all: boolean;
	  }
	| (Record<K, boolean> & { all?: never });
